// ----------------------------------------------------------------------

import palette from "./palette";

function pxToRem(value) {
  return `${value / 16}rem`;
}

function responsiveFontSizes({ sm, md, lg }) {
  return {
    "@media (min-width:600px)": {
      fontSize: pxToRem(sm),
    },
    "@media (min-width:900px)": {
      fontSize: pxToRem(md),
    },
    "@media (min-width:1200px)": {
      fontSize: pxToRem(lg),
    },
  };
}

function responsiveLineHeights({ sm, md, lg }) {
  return {
    "@media (min-width:600px)": {
      lineHeight: pxToRem(sm),
    },
    "@media (min-width:900px)": {
      lineHeight: pxToRem(md),
    },
    "@media (min-width:1200px)": {
      lineHeight: pxToRem(lg),
    },
  };
}

const FONT_PRIMARY = "Inter, sans-serif";

const typography = {
  fontFamily: FONT_PRIMARY,
  fontWeightRegular: 400,
  fontWeightMedium: 600,
  fontWeightBold: 700,
  h1: {
    fontWeight: 800,
    lineHeight: 1.2,
    fontSize: pxToRem(32),
    ...responsiveFontSizes({ sm: 32, md: 48, lg: 80 }),
  },
  h2: {
    fontWeight: 800,
    lineHeight: 1.2,
    fontSize: pxToRem(20),
    ...responsiveFontSizes({ sm: 20, md: 32, lg: 48 }),
  },
  h3: {
    fontWeight: 800,
    lineHeight: 1.2,
    fontSize: pxToRem(18),
    ...responsiveFontSizes({ sm: 18, md: 24, lg: 32 }),
  },
  h4: {
    fontWeight: 800,
    lineHeight: 1.2,
    fontSize: pxToRem(16),
    ...responsiveFontSizes({ sm: 16, md: 18, lg: 24 }),
  },
  // h5-6 weren't defined on figma, so we had them match h4
  h5: {
    fontWeight: 800,
    lineHeight: 1.2,
    fontSize: pxToRem(14),
    ...responsiveFontSizes({ sm: 14, md: 16, lg: 20 }),
  },
  h6: {
    fontWeight: 800,
    lineHeight: 1.2,
    fontSize: pxToRem(12),
    ...responsiveFontSizes({ sm: 12, md: 14, lg: 18 }),
  },
  subtitle1: {
    fontWeight: 600,
    lineHeight: 1.5,
    fontSize: pxToRem(16),
  },
  subtitle2: {
    fontWeight: 600,
    lineHeight: 22 / 14,
    fontSize: pxToRem(14),
  },
  body1: {
    lineHeight: 1.3,
    fontSize: pxToRem(16),
    "@media (min-width:900px)": {
      lineHeight: 1.4,
      fontSize: pxToRem(18),
    },
  },
  body2: {
    lineHeight: 1.3,
    fontSize: pxToRem(14),
    "@media (min-width:900px)": {
      lineHeight: 1.4,
      fontSize: pxToRem(16),
    },
  },
  body3: {
    paragraph: true,
    lineHeight: 1.4,
    fontSize: pxToRem(10),
    fontWeight: 300,
    color: "text.secondary",
    "@media (min-width:900px)": {
      fontSize: pxToRem(12),
    },
  },
  gradientheader: {
    lineHeight: 1.3,
    fontSize: pxToRem(14),
    "@media (min-width:900px)": {
      lineHeight: 1.4,
      fontSize: pxToRem(16),
    },
    fontWeight: 700,
    color: "transparent",
    background: palette.gradients.primary,
    WebkitBackgroundClip: "text",
  },
  caption: {
    fontWeight: 800,
    lineHeight: 1.2,
    fontSize: pxToRem(12),
  },
  overline: {
    fontWeight: 700,
    lineHeight: 1.5,
    fontSize: pxToRem(12),
    letterSpacing: 1.1,
    textTransform: "uppercase",
  },
  button: {
    fontWeight: 400,
    lineHeight: 16 / 14,
    ...responsiveLineHeights({ sm: 16 / 14, md: 20 / 16, lg: 24 / 20 }),
    fontSize: pxToRem(14),
    ...responsiveFontSizes({ sm: 14, md: 16, lg: 20 }),
    textTransform: "capitalize",
  },
};

export default typography;
